<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="postId" :label="$t('帖子ID')">
<!--        <span slot="label" >
          <a-tooltip>
            帖子ID，外键{discover_post.id}<template slot="title">帖子ID，外键{discover_post.id}</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.postId"  :placeholder="$t('请输入')+$t('帖子ID')" />
      </a-form-model-item>
      <a-form-model-item prop="sort" :label="$t('人工排序值')">
<!--        <span slot="label" >
          <a-tooltip>
            人工排序值，数值越小越靠前<template slot="title">人工排序值，数值越小越靠前</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.sort"  :placeholder="$t('请输入')+$t('人工排序值')" />
      </a-form-model-item>
      <a-form-model-item prop="isEnabled" :label="$t('是否启用')">
<!--        <span slot="label" >
          <a-tooltip>
            是否启用，1=是 0=否<template slot="title">是否启用，1=是 0=否</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.isEnabled"  :placeholder="$t('请输入')+$t('是否启用')" />
      </a-form-model-item>
      <a-form-model-item prop="publishTime" :label="$t('文章发布时间')">
<!--        <span slot="label" >
          <a-tooltip>
            文章发布时间<template slot="title">文章发布时间</template>
          </a-tooltip>
        </span>-->
        <a-date-picker style="width: 100%" v-model="form.publishTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="remark" :label="$t('备注')">
<!--        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoverHotPostConf, addDiscoverHotPostConf, updateDiscoverHotPostConf } from '@/api/discover/discoverHotPostConf'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        postId: null,

        sort: null,

        isEnabled: null,

        publishTime: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        postId: [
          { required: true, message: '帖子ID，外键{discover_post.id}'+this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '人工排序值，数值越小越靠前'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isEnabled: [
          { required: true, message: '是否启用，1=是 0=否'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        postId: null,
        sort: null,
        isEnabled: null,
        publishTime: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoverHotPostConf({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoverHotPostConf(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoverHotPostConf(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
